import { render, staticRenderFns } from "./SiteNav.vue?vue&type=template&id=187a541b&scoped=true&"
import script from "./SiteNav.vue?vue&type=script&lang=js&"
export * from "./SiteNav.vue?vue&type=script&lang=js&"
import style0 from "./SiteNav.vue?vue&type=style&index=0&id=187a541b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a541b",
  null
  
)

export default component.exports